export default import.meta.ROLLDOWN_FILE_URL_qFNlkODIo1nj_GRT4FJaRQ